// the backend stores intervals in days, months and years are approximated
export const durationUnits = [
    { name: 'days', singular: 'day', factor: 1 },
    { name: 'weeks', singular: 'week', factor: 7 },
    { name: 'months', singular: 'month', factor: 30 },
    { name: 'years', singular: 'year', factor: 365 },
];

// largest unit that divides the days evenly, 0 (no interval) defaults to months
export function splitDays(days: number) {
    if (!days)
        return { amount: days || 0, factor: 30 };
    const unit = [...durationUnits].reverse().find(u => days % u.factor === 0) ?? durationUnits[0]; // fractional days stay days
    return { amount: days / unit.factor, factor: unit.factor };
}

export function formatDays(days: number, translate: (text: string) => string = t => t) {
    if (!days)
        return '';
    const { amount, factor } = splitDays(days);
    const unit = durationUnits.find(u => u.factor === factor)!;
    return amount + ' ' + translate(amount === 1 ? unit.singular : unit.name);
}
